export default "__VITE_ASSET__BHQdW5fJ__"